import { module as BaseModule } from 'modujs'

export default class extends BaseModule {
  constructor(m) {
    super(m)

    this.events = {
      click: {
        toggle: 'toggle',
      },
    }
  }

  init() {
    this.state = false
    this.checkbox = this.el.querySelector('input')
    if (this.checkbox.checked === true) this.toggle()
  }

  toggle(e) {
    if (e) e.preventDefault()
    this.state = !this.state
    this.checkbox.checked = this.state
    this.el.classList.toggle('--active', this.state)
  }
}
